/* tslint:disable */
/* eslint-disable */
/**
 * Scrivio User Roles API
 * Scrivio API for user role assignments.  ## Authentication All endpoints require Firebase Authentication JWT token in `Authorization: Bearer <token>` header.  ## Error Responses All error responses follow RFC 7807 Problem Details format. 
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@scrivio.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

export interface ProblemDetail {
    /**
     * A URI reference that identifies the problem type
     */
    'type': string;
    /**
     * A short, human-readable summary of the problem
     */
    'title': string;
    /**
     * The HTTP status code
     */
    'status': number;
    /**
     * A human-readable explanation specific to this occurrence
     */
    'detail'?: string;
    /**
     * A URI reference that identifies the specific occurrence
     */
    'instance'?: string;
    /**
     * List of validation errors
     */
    'errors'?: Array<ProblemDetailErrorsInner>;
}
export interface ProblemDetailErrorsInner {
    'field'?: string;
    'message'?: string;
}
export interface UpdateUserRolesRequest {
    /**
     * List of role IDs to assign to the user
     */
    'roleIds': Array<string>;
}
export interface UserRoleResponse {
    /**
     * Role ID
     */
    'roleId': string;
    /**
     * Role name
     */
    'roleName': string;
    /**
     * Role description
     */
    'roleDescription'?: string | null;
    /**
     * List of permissions from this role
     */
    'permissions'?: Array<string>;
    /**
     * Assignment timestamp in milliseconds
     */
    'createdAt': number;
}

/**
 * UserRolesApi - axios parameter creator
 */
export const UserRolesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns all roles assigned to a user
         * @summary Get user\'s roles
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserRoles: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserRoles', 'userId', userId)
            const localVarPath = `/api/v1/users/{userId}/roles`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Replace all roles for a user (requires admin privileges)
         * @summary Update user\'s roles
         * @param {string} userId User ID
         * @param {UpdateUserRolesRequest} updateUserRolesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserRoles: async (userId: string, updateUserRolesRequest: UpdateUserRolesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUserRoles', 'userId', userId)
            // verify required parameter 'updateUserRolesRequest' is not null or undefined
            assertParamExists('updateUserRoles', 'updateUserRolesRequest', updateUserRolesRequest)
            const localVarPath = `/api/v1/users/{userId}/roles`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserRolesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserRolesApi - functional programming interface
 */
export const UserRolesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserRolesApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns all roles assigned to a user
         * @summary Get user\'s roles
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserRoles(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserRoleResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserRoles(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserRolesApi.getUserRoles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Replace all roles for a user (requires admin privileges)
         * @summary Update user\'s roles
         * @param {string} userId User ID
         * @param {UpdateUserRolesRequest} updateUserRolesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserRoles(userId: string, updateUserRolesRequest: UpdateUserRolesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserRoleResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserRoles(userId, updateUserRolesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserRolesApi.updateUserRoles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserRolesApi - factory interface
 */
export const UserRolesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserRolesApiFp(configuration)
    return {
        /**
         * Returns all roles assigned to a user
         * @summary Get user\'s roles
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserRoles(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<UserRoleResponse>> {
            return localVarFp.getUserRoles(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Replace all roles for a user (requires admin privileges)
         * @summary Update user\'s roles
         * @param {string} userId User ID
         * @param {UpdateUserRolesRequest} updateUserRolesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserRoles(userId: string, updateUserRolesRequest: UpdateUserRolesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<UserRoleResponse>> {
            return localVarFp.updateUserRoles(userId, updateUserRolesRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserRolesApi - object-oriented interface
 */
export class UserRolesApi extends BaseAPI {
    /**
     * Returns all roles assigned to a user
     * @summary Get user\'s roles
     * @param {string} userId User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUserRoles(userId: string, options?: RawAxiosRequestConfig) {
        return UserRolesApiFp(this.configuration).getUserRoles(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Replace all roles for a user (requires admin privileges)
     * @summary Update user\'s roles
     * @param {string} userId User ID
     * @param {UpdateUserRolesRequest} updateUserRolesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateUserRoles(userId: string, updateUserRolesRequest: UpdateUserRolesRequest, options?: RawAxiosRequestConfig) {
        return UserRolesApiFp(this.configuration).updateUserRoles(userId, updateUserRolesRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



